import script from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"

import "../css/style.css?vue&type=style&index=0&id=66cbe2ca&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cbe2ca"]])

export default __exports__